<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class="layout--main"
    :class="[
      layoutTypeClass,
      navbarClasses,
      footerClasses,
      { 'app-page': isAppPage },
    ]"
  >
    <vx-tour
      :steps="steps"
      v-if="
        !disableThemeTour &&
        windowWidth >= 1200 &&
        mainLayoutType === 'vertical'
      "
    />

    <the-customizer
      v-if="!disableCustomizer"
      :footerType="footerType"
      :hideScrollToTop="hideScrollToTop"
      :navbarType="navbarType"
      :navbarColor="navbarColor"
      :routerTransition="routerTransition"
      @toggleHideScrollToTop="toggleHideScrollToTop"
      @updateFooter="updateFooter"
      @updateNavbar="updateNavbar"
      @updateNavbarColor="updateNavbarColor"
      @updateRouterTransition="updateRouterTransition"
    />

    <v-nav-menu
      color="primary"
      :navMenuItems="navMenuItems"
      :logo="logo"
      :title="appName"
      parent=".layout--main"
    />

    <div
      id="content-area"
      :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]"
    >
      <div id="content-overlay" />

      <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
        <the-navbar-horizontal
          :navbarType="navbarType"
          :logo="navMenuLogo"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
        />

        <div style="height: 62px" v-if="navbarType === 'static'"></div>

        <h-nav-menu
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
          :navMenuItems="navMenuItems"
        />
      </template>

      <template v-else>
        <the-navbar-vertical
          :navbarColor="navbarColor"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
        />
      </template>
      <!-- /Navbar -->

      <div class="content-wrapper">
        <div class="router-view">
          <div class="router-content">
            <transition :name="routerTransition">
              <div
                v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
                class="router-header flex flex-wrap items-center mb-6"
              >
                <div
                  class="content-area__heading"
                  :class="{
                    'pr-4 border-0 md:border-r border-solid border-grey-light':
                      $route.meta.breadcrumb,
                  }"
                >
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb
                  class="ml-4 md:block hidden"
                  v-if="$route.meta.breadcrumb"
                  :route="$route"
                />

                <!-- DROPDOWN -->
                <!--vs-dropdown vs-trigger-click class="ml-auto md:block hidden cursor-pointer">
                                  <vs-button radius icon="icon-settings" icon-pack="feather" />

                                  <vs-dropdown-menu class="w-32">
                                    <vs-dropdown-item>
                                      <div @click="$router.push('/pages/profile').catch(() => {})" class="flex items-center">
                                        <feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                                        <span>Profile</span>
                                      </div>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item>
                                      <div @click="$router.push('/apps/todo').catch(() => {})" class="flex items-center">
                                        <feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                                        <span>Tasks</span>
                                      </div>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item>
                                      <div @click="$router.push('/apps/email').catch(() => {})" class="flex items-center">
                                        <feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                                        <span>Inbox</span>
                                      </div>
                                    </vs-dropdown-item>
                                  </vs-dropdown-menu>

                                </vs-dropdown-->
              </div>
            </transition>

            <div class="content-area__content">
              <back-to-top
                bottom="5%"
                visibleoffset="500"
                v-if="!hideScrollToTop"
              >
                <vs-button
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg btn-back-to-top"
                />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer />
    </div>
  </div>
</template>


<script>
import BackToTop from "vue-backtotop";
import HNavMenu from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue";
// import navMenuItems        from "@/layouts/components/vertical-nav-menu/navMenuItems.js"
import TheCustomizer from "@/layouts/components/customizer/TheCustomizer.vue";
import TheNavbarHorizontal from "@/layouts/components/navbar/TheNavbarHorizontal.vue";
import TheNavbarVertical from "@/layouts/components/navbar/TheNavbarVertical.vue";
import TheFooter from "@/layouts/components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import VNavMenu from "@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue";

const VxTour = () => import("@/components/VxTour.vue");

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheCustomizer,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    VxTour,
  },
  data() {
    return {
      disableCustomizer: themeConfig.disableCustomizer,
      disableThemeTour: themeConfig.disableThemeTour,
      footerType: themeConfig.footerType || "static",
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || "#fff",
      navbarType: themeConfig.navbarType || "floating",
      // navMenuItems      : navMenuItems,
      navMenuLogo: require("@/assets/images/logo/mtn-logo-nav.svg"),
      routerTransition: themeConfig.routerTransition || "none",
      routeTitle: this.$route.meta.pageTitle,
      steps: [
        {
          target: "#btnVNavMenuMinToggler",
          content: "Toggle Collapse Sidebar.",
        },
        {
          target: ".vx-navbar__starred-pages",
          content:
            "Create your own bookmarks. You can also re-arrange them using drag & drop.",
        },
        {
          target: ".i18n-locale",
          content: "You can change language from here.",
        },
        {
          target: ".navbar-fuzzy-search",
          content: "Try fuzzy search to visit pages in flash.",
        },
        {
          target: ".customizer-btn",
          content: "Customize template based your preference",
          params: {
            placement: "left",
          },
        },
      ],
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff";
      this.updateNavbarColor(color);
    },
    "$store.state.mainLayoutType"(val) {
      this.setNavMenuVisibility(val);
      this.disableThemeTour = true;
    },
    windowWidth(val) {
      if (val < 1200) this.disableThemeTour = true;
    },
    verticalNavMenuWidth() {
      this.disableThemeTour = true;
    },
  },
  computed: {
    logo() {
      const setting_logo =
        this.$http.defaults.baseURL.replace("/api/", "") +
        JSON.parse(localStorage.getItem("settings")).logo.path;
      const logo = require("@/assets/images/logo/mtn-logo-nav.svg");

      if (JSON.parse(localStorage.getItem("settings")).logo.path) {
        return setting_logo;
      } else return logo;
    },
    appName() {
      const default_name = "MTN-OTD";
      if (JSON.parse(localStorage.getItem("settings")).app_name) {
        return JSON.parse(localStorage.getItem("settings")).app_name;
      } else return default_name;
    },
    navMenuItems() {
      if (
        this.$store.state.AppActiveUser &&
        this.$store.state.AppActiveUser.roles
      ) {
        var isAdmin = window.getApp.isAdmin();
        var isAgent = window.getApp.isAgent();
        var isTeamChef = window.getApp.isTeamChef();
        var isSuperVisorRegion = window.getApp.isRegionalSupervisor();
        var array = [];
        var agentArray = [];
        var submenuEvaluation = [
          {
            url: null,
            name: "Evaluations",

            submenu: [
              {
                url: "/evaluation/all",
                name: "Index",
                slug: "evaluation-all",
              },
            ],
          },
        ];

        if (isAgent) {
          agentArray.push({
            url: "/dashboard",
            name: "Tableau de bord",
            slug: "email",
            icon: "HomeIcon",
          });
          agentArray.push({
            url: "/formation/all",
            name: "Formation",
            slug: "formation",
            icon: "LayersIcon",
          });
          agentArray.push({
            url: "/forum/all",
            name: "Forum",
            icon: "MessageCircleIcon",
            slug: "ecommerce-shop",
          });

          submenuEvaluation.unshift({
            slug: "evaluation-resultat-detail",
            url: "/evaluation/resultat/detail",
            name: "Mes Résultats",
          });

          agentArray.push({
            url: null,
            name: "Evaluations",
            icon: "FileMinusIcon",
            submenu: [
              {
                url: "/evaluation/users",
                name: "Index",
                slug: "evaluation-users",
              },
              {
                url: "/evaluation/users/resultats",
                name: "Mes résultats",
                slug: "evaluation-resultats",
              },
            ],
          });
          agentArray.push({
            url: null,
            name: "Performances",
            icon: "SlidersIcon",
            submenu: [
              {
                slug: "performance-periods-saisie",
                url: "/performance/agent",
                name: "Mes performances",
              },
            ],
          });
          agentArray.push({
            url: "/livechat",
            name: "Live Chat",
            icon: "FilmIcon",
            slug: "livechat",
          });
          agentArray.push({
            url: "/profile",
            name: "Profil",
            slug: "user-profile",
            icon: "UserIcon",
            tagColor: "success",
          });
          return agentArray;
        } else {
          // dashboard
          array.push({
            url: "/dashboard",
            name: "Tableau de bord",
            slug: "email",
            icon: "HomeIcon",
          });

          //
          array.push({
            url: "/formation/all/agent",
            name: "Formation",
            slug: "formation",
            icon: "LayersIcon",
          });

          //
          array.push({
            url: null,
            name: "Forum",
            icon: "MessageCircleIcon",
            submenu: [
              {
                url: "/forum/all",
                name: "Index",
                slug: "ecommerce-shop",
              },
            ],
          });

          //
          array.push({
            url: "/profile",
            name: "Profil",
            slug: "user-profile",
            icon: "UserIcon",
            tagColor: "success",
          });

          //
          // var submenuEvaluation = [];

          if (isAgent) {
            submenuEvaluation.unshift({
              slug: "evaluation-resultat-detail",
              url: "/evaluation/resultat/detail",
              name: "Mes Résultats",
            });
          }
          if (isTeamChef) {
            submenuEvaluation.unshift({
              url: "/evaluation/users/resultats",
              name: "Mes résultats",
              slug: "evaluation-resultats",
            });
          }

          if (isAdmin) {
            submenuEvaluation.unshift({
              slug: "evaluation-resultat",
              url: "/evaluation/resultat",
              name: "Résultats",
            });
          }

          if (isAdmin) {
            submenuEvaluation.unshift({
              url: "/evaluation/category",
              name: "Catégorie",
              slug: "evaluation-category",
            });
            submenuEvaluation.unshift({
              url: "/evaluation/streams",
              name: "Streams",
              slug: "evaluation-stream",
            });
          }

          var submenuPerformanceObject = {};

          if (isAdmin) {
            var submenuPerformance = [
              {
                slug: "performance-periods-saisie",
                url: "/performance/saisiePerformance",
                name: "Saisie de performances",
              },
              {
                url: null,
                name: "Paramètres",
                submenu: [
                  {
                    slug: "performance-periods",
                    url: "/performance/periods",
                    name: "Périodes",
                  },
                ],
              },
            ];

            submenuPerformanceObject = {
              url: null,
              name: "Performances",
              icon: "SlidersIcon",
              submenu: submenuPerformance,
            };
          }

          var submenuFormation1 = [
            {
              url: "/formation/all",
              name: "Toutes les formations",
              slug: "formation-all",
            },
          ];

          var packFormationMenu = [];
          var submenuPackFormation = [
            {
              url: "/formation/packs/list",
              name: "Tous",
              slug: "formation-packs-list",
            },
            {
              url: "/formation/packs/certified-users",
              name: "Liste des certifiés",
              slug: "formation-packs-certified-users",
            },
          ];

          if (isAdmin) {
            submenuFormation1.push({
              url: "/formation/category",
              name: "Catégorie",
              slug: "formation-category",
            });
            var packFormationMenu = {
              url: null,
              name: "Pack formations",
              tagColor: "primary",
              submenu: submenuPackFormation,
            };
          }

          /*  if (isAdmin) {
                        submenuFormation1.push({
                            url: '/formation/statistique/show',
                            name: "Statistiques",
                            slug: "formation-statistics"
                        });
                    }*/

          var itemsAdministration = [
            {
              url: null,
              name: "Formation",
              //tag: "new",
              tagColor: "primary",
              icon: "LayersIcon",
              submenu: submenuFormation1,
            },
            {
              url: null,
              name: "Packs formation",
              tagColor: "primary",
              icon: "LayersIcon",
              submenu: submenuPackFormation,
            },
            {
              url: null,
              name: "Forum",
              icon: "MessageCircleIcon",

              submenu: [
                {
                  url: "/forum/all",
                  name: "Modérer",
                  slug: "forum",
                },
                {
                  url: "/forum/category",
                  name: "Catégorie",
                  slug: "forum-category",
                },
                {
                  url: "/forum/statistique/show",
                  name: "Statistiques",
                  slug: "forum-statistics",
                },
              ],
            },
            {
              url: null,
              name: "Evaluations",
              icon: "FileMinusIcon",
              submenu: submenuEvaluation,
            },
          ];

          if (isAdmin) {
            itemsAdministration.push(submenuPerformanceObject);
          }

          if (isTeamChef || isSuperVisorRegion) {
            itemsAdministration = itemsAdministration.filter(
              (element) => element.name != "Formation"
            );
            itemsAdministration = itemsAdministration.filter(
              (element) => element.name != "Forum"
            );
          }

          array.push({
            header: "Administration",
            icon: "LayersIcon",

            items: itemsAdministration,
          });

          if (isAdmin) {
            //
            array.push({
              url: "/message/all",
              name: "Messages",
              slug: "email",
              icon: "MailIcon",
            });
          }
          if (isTeamChef) {
            array.push({
              url: null,
              name: "Performances",
              icon: "SlidersIcon",
              submenu: [
                {
                  slug: "performance-periods-saisie",
                  url: "/performance/agent",
                  name: "Mes performances",
                },
                {
                  slug: "performance-periods-saisie",
                  url: "/performance/saisiePerformance",
                  name: "Saisie de performances",
                },
              ],
            });
          }
          //
          array.push({
            url: "/livechat",
            name: "Live Chat",
            icon: "FilmIcon",
            slug: "livechat",
          });

          if (isAdmin) {
            //
            array.push({
              url: "/monitoring",
              name: "Monitoring",
              icon: "MinusSquareIcon",
              slug: "monitoring",

              /*submenu: [
                              {
                                url: '/monitoring',
                                name: "Audit Trail",
                                icon: "BookOpenIcon",
                                slug: "monitoring",


                              },
                              {
                                url: null,
                                name: "Analytics",
                                icon: "BookOpenIcon",
                                slug: "monitoring-analytics",


                              },
                            ]*/
            });
          }

          if (isAdmin) {
            //
            array.push({
              url: null,
              name: "Utilisateurs",
              icon: "UsersIcon",

              submenu: [
                {
                  url: "/users/all",
                  name: "Index",
                  icon: "BookOpenIcon",
                  slug: "externall",
                },
                {
                  url: "/users/create",
                  name: "Ajouter",
                  icon: "BookOpenIcon",
                  slug: "externall",
                },
                {
                  url: "/users/add-import",
                  name: "Ajouter par lot",
                  icon: "BookOpenIcon",
                  slug: "externall",
                },
                {
                  url: "/users/import",
                  name: "Supprimer par lot",
                  icon: "BookOpenIcon",
                  slug: "externall",
                },
                {
                  url: "/users/account-deletion-requests",
                  name: "Demande de suppression",
                  icon: "BookOpenIcon",
                  slug: "externall",
                },
              ],
            });
          }

          if (isAdmin) {
            //
            array.push({
              url: null,
              name: "Statistiques et Rapports",
              icon: "SettingsIcon",

              submenu: [
                {
                  url: "/ttc/reports/reports-ttc",
                  name: "Rapports TTC",
                  slug: "ttc-reports",
                },
                {
                  url: "/formation/stats",
                  name: "Formations par agent",
                  slug: "formation-stats",
                },
                {
                  url: "/formation/stats/teams",
                  name: "Formations par équipe",
                  slug: "formation-stats-by-user",
                },
                {
                  url: "/stats/users-by-day",
                  name: "Nombre d’utilisateurs connectés journalièrement",
                  slug: "stats-user-by-day",
                },
                {
                  url: "/forum/stats",
                  name: "Forums",
                  slug: "forum-stat",
                },
                {
                  url: "/connaissances/stats",
                  name: "Test tes connaissances",
                  slug: "connaissances-stats",
                },
                {
                  url: "/Performance/stats",
                  name: "Performances",
                  slug: "Performance-stats",
                },
                {
                  url: "/evaluations/stats/missing-questions",
                  name: "Top 10 des questions ratées",
                  slug: "missing_questions",
                },
                {
                  url: "/evaluations/results/not-composed",
                  name: "Utilisateurs n'ayant pas composé",
                  slug: "evals_not_composed_users",
                },
              ],
            });
          }

          if (isAdmin) {
            //
            array.push({
              url: null,
              name: "Paramètres",
              icon: "SettingsIcon",
              submenu: [
                {
                  url: "/settings/cutting",
                  name: "Découpage",
                  slug: "cutting",
                },
                {
                  url: "/settings/global",
                  name: "Généraux",
                  slug: "global",
                },
              ],
            });
          }

          return array;
        }
      } else return [];
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.mainLayoutType === "vertical") {
        if (this.verticalNavMenuWidth == "default")
          return "content-area-reduced";
        else if (this.verticalNavMenuWidth == "reduced")
          return "content-area-lg";
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full";
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static",
      };
    },
    isAppPage() {
      return this.$route.path.includes("/apps/") ? true : false;
    },
    isThemeDark() {
      return this.$store.state.theme == "dark";
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`;
    },
    mainLayoutType() {
      return this.$store.state.mainLayoutType;
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating",
      };
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      if (val == "static") this.updateNavbarColor("#fff");
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    setNavMenuVisibility(layoutType) {
      if (
        (layoutType === "horizontal" && this.windowWidth >= 1200) ||
        (layoutType === "vertical" && this.windowWidth < 1200)
      ) {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
        this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");
      } else {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    },
  },
  created() {
    const color =
      this.navbarColor == "#fff" && this.isThemeDark
        ? "#10163a"
        : this.navbarColor;
    this.updateNavbarColor(color);
    this.setNavMenuVisibility(this.$store.state.mainLayoutType);
  },
};
</script>

